module.exports = __webpack_public_path__ + "gn.08eac752cd2b0fa02809.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gn.svg
// module chunks = styles